export default "__VITE_PUBLIC_ASSET__3a4f2e98__"